import type { OrderDiscountItemModel } from '~/models/order/OrderReceipt.api.model';

export function shouldExcludeDiscountFromDisplay(discount: OrderDiscountItemModel): boolean {
  if (discount.Name?.toLowerCase().includes('försäkring')) {
    return true;
  }
  if (discount.DiscountType === 'FreeProduct') {
    return true;
  }
  return false;
}
